import type { ReportAnswers } from '../../../../report/CustomerReport';
import { isAnswerValueSelected } from '../../../../report/getQuestion';
import { PoliceFireCrewStatus } from '../../../../report/questions/problemType/EmergencyResponse';
import { ReportQuestion, StandardAnswerValue } from '../../../../report/questions/ReportQuestion';
import { CallerTypeQuestionValue } from '../../../../report/questions/reporter/CallerTypeQuestion';

export function isPoliceFire(answers: ReportAnswers): boolean {
	return isAnswerValueSelected(answers, ReportQuestion.CallerType, CallerTypeQuestionValue.PoliceFire);
}

// Shortcut to see if something meets police / fire standby criteria
export function meetsPoliceFireStandbyCriteria(answers: ReportAnswers): boolean {
	// Issue is reported by police fire
	const policeFire = isPoliceFire(answers);
	if (!policeFire) {
		return false;
	}

	const fireOption = isAnswerValueSelected(answers, ReportQuestion.Fire, StandardAnswerValue.Other);
	if (fireOption) {
		return true;
	}

	// Police / fire have said they're standing by
	// return isAnswerValueSelected(answers, ReportQuestion.EmergencyResponse, [PoliceFireCrewStatus.Standby]);
	const pFireStandBy = isAnswerValueSelected(answers, ReportQuestion.EmergencyResponse, [
		PoliceFireCrewStatus.Standby,
	]);

	if (pFireStandBy !== undefined) {
		return pFireStandBy;
	}

	return true;
}
